import { Utilities as U } from "@shared/utilities/utilities.model";

export enum EBaseCostPoField {
  CONTRACT_TYPE        = 'contract_type',
  CLOSURE_TYPE         = 'closure_type',
  AT_HEADQUARTERS      = 'at_headquarters',
  HOME_CLOSING         = 'home_closing',
  BASE_COST            = 'base_cost',
  ADDITIONAL_KM_COST   = 'additional_km_cost',
  KM_FROM              = 'km_from',
  KM_TO                = 'km_to',
  ID                   = 'id',
  SUPPLIER             = 'supplier',
  SUPPLIER_DESCRIPTION = 'supplier_description',
}
export class BaseCostPo {
  
  [EBaseCostPoField.CONTRACT_TYPE]        : EContractType | string;
  [EBaseCostPoField.CLOSURE_TYPE]         : EClosureType | string;
  [EBaseCostPoField.AT_HEADQUARTERS]      : boolean = false;
  [EBaseCostPoField.HOME_CLOSING]         : boolean = false;
  [EBaseCostPoField.BASE_COST]            : number;
  [EBaseCostPoField.ADDITIONAL_KM_COST]   : number;
  [EBaseCostPoField.KM_FROM]              : number;
  [EBaseCostPoField.KM_TO]                : number;
  [EBaseCostPoField.ID]                   : string = '';

  // supplier e supplier_description saranno visualizzati solo se home_closing = true
  [EBaseCostPoField.SUPPLIER]             : string = '';
  [EBaseCostPoField.SUPPLIER_DESCRIPTION] : string = '';

	constructor(model?: any) {
    
		if (U.isEmpty(model)) {
			return;
		}
    
    Object.assign(this, model);
    this[EBaseCostPoField.ADDITIONAL_KM_COST] = U.nullish(model.additional_km_cost, 0);
  }
};

export class BaseCostPoRequestBody {
  
  [EBaseCostPoField.BASE_COST]?          : number;
  [EBaseCostPoField.ADDITIONAL_KM_COST]? : number;
  [EBaseCostPoField.KM_FROM]?            : number;
  [EBaseCostPoField.KM_TO]?              : number;
  [EBaseCostPoField.ID]?                 : string = '';
  [EBaseCostPoField.HOME_CLOSING]?       : boolean = false;

	constructor(model?: any) {
    
		if (U.isEmpty(model)) {
			return;
		}
    
    this[EBaseCostPoField.BASE_COST]          = model[EBaseCostPoField.BASE_COST];
    this[EBaseCostPoField.ADDITIONAL_KM_COST] = U.nullish(model[EBaseCostPoField.ADDITIONAL_KM_COST], 0);
    this[EBaseCostPoField.KM_FROM]            = model[EBaseCostPoField.KM_FROM];
    this[EBaseCostPoField.KM_TO]              = model[EBaseCostPoField.KM_TO];
    this[EBaseCostPoField.ID]                 = model[EBaseCostPoField.ID];
    this[EBaseCostPoField.HOME_CLOSING]       = model[EBaseCostPoField.HOME_CLOSING];
  }
};

export enum EClosureType {
	CLOSURE_WITH_SURVEYOR               = 'CLOSURE_WITH_SURVEYOR',
	CLOSURE_WITHOUT_SURVEYOR            = 'CLOSURE_WITHOUT_SURVEYOR',
	CLOSURE_WITH_TEMPLATE               = 'CLOSURE_WITH_TEMPLATE',
	CLOSURE_WITH_TEMPLATE_WITH_SURVEYOR = 'CLOSURE_WITH_TEMPLATE_WITH_SURVEYOR',
};


// Guardare EsbContractModel
enum EContractType {
	EXCHANGE1 = 'EXCHANGE1',
	EXCHANGE2 = 'EXCHANGE2',
	RETURN    = 'RETURN',
};

export enum ECCDeliveryType {
  WITH_LOGISTICS = 'WITH_LOGISTICS'
}